import type { CustomSocialWalletContextType } from './CustomSocialWalletProvider.types';
import type { BlockchainMeta } from '../../api/models/MetaModels';

import { SocialWalletProvider } from '@rango-dev/internal-social-wallet';
import React, { createContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { PRIVY_APP_ID } from '../../constants/common';
import { useAppSelector } from '../../hooks/reduxHooks';

export const CustomSocialWalletProviderContext = createContext<CustomSocialWalletContextType>({
  supportedChains: [],
  setSupportedChains: () => {},
});

export const CustomSocialWalletProvider = ({ children }: { children: React.ReactNode }) => {
  const { isDarkMode } = useAppSelector((state) => state.settings);
  const { t } = useTranslation();
  const [supportedChains, setSupportedChains] = useState<BlockchainMeta[]>([]);

  const contextValue = React.useMemo(
    () => ({ supportedChains, setSupportedChains }),
    [supportedChains],
  );

  return (
    <CustomSocialWalletProviderContext.Provider value={contextValue}>
      <SocialWalletProvider
        appId={PRIVY_APP_ID}
        supportedChains={supportedChains}
        appearance={{
          landingHeader: t('Connect via Social account'),
          logo: '/imgs/wallets/rango-social-wallet-logo.svg',
          theme: isDarkMode ? 'dark' : 'light',
        }}>
        {children}
      </SocialWalletProvider>
    </CustomSocialWalletProviderContext.Provider>
  );
};
